module.exports = __webpack_public_path__ + "img/shedBg2.b848fde0.png";